const profit = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default profit;
